var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25,
    d: "M17.865 15.538l6.344 6.53a1.034 1.034 0 010 1.445l-.669.689a.966.966 0 01-1.403 0l-6.54-6.733a10.141 10.141 0 01-5.326 1.49C4.875 18.959.5 14.827.5 9.729.5 4.633 4.875.5 10.271.5c5.397 0 9.772 4.132 9.772 9.23 0 2.2-.816 4.222-2.178 5.808zm-7.594 1.575c4.317 0 7.817-3.306 7.817-7.383 0-4.078-3.5-7.384-7.817-7.384S2.454 5.652 2.454 9.73c0 4.077 3.5 7.383 7.817 7.383z"
  })));
}

export default SvgCommonIconSearch;